<h1 class="page-title">Kapcsolat</h1>
<!--<h2>Alkalmaink</h2>-->
<p class="main-info">
  Istentiszteleteink <br/>
  <strong>vasárnap 16 órakor</strong><br/>
  kezdődnek a<br/>
  <strong>KKK közösségi házban</strong><br/>
  (7400 Kaposvár, Kanizsai u. 56. [Roberto csempe áruház mellett])
</p>

<h2>Egyéb elérhtőségeink</h2>

<div class="row">
  <div class="col-xl-6">
  <table>
    <tbody>
    <tr>
      <td class="text-right">E-mail:</td>
      <td>kapkerkoz (kukac) gmail.com</td>
    </tr>
    <tr>
      <td class="text-right">KKK közösségi ház:</td>
      <td>7400 Kaposvár, Kanizsai u. 56.<br/>[Roberto csempe áruház mellett]</td>
    </tr>
    <tr>
      <td class="text-right">Gyülekezetünk lelkipásztora:</td>
      <td>Fodor János - 70/701 7834</td>
    </tr>
    </tbody>
  </table>
  </div>

  <div class="col-xl-6">
    <iframe height="450"
            style="width: 100%;"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            src="https://maps.google.com/maps?q=roberto+csempearuhaz&amp;output=embed"
    ></iframe>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/who-we-are/contact/contact.component.html